interface ParallaxState {
  currentX: number;
  currentY: number;
  targetX: number;
  targetY: number;
}

export const initHomeCarousel = (): void => {
  const carouselElement = document.querySelector<HTMLElement>(".home-carousel");
  if (!carouselElement) return;

  // Extract Swiper from Core Plugin vendors
  const rawSwiper = window.EcommerceCore.vendors.Swiper;
  const Swiper = (rawSwiper as any).default || rawSwiper;
  const { Navigation, Autoplay, EffectFade, Pagination } =
    window.EcommerceCore.vendors.SwiperModules;

  // WeakMap to strictly track X/Y coordinates
  const parallaxStates = new WeakMap<HTMLElement, ParallaxState>();

  // Removed unused variable 'swiper'
  new Swiper(carouselElement, {
    modules: [Navigation, Autoplay, EffectFade, Pagination],
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".home-carousel-next",
      prevEl: ".home-carousel-prev",
    },
    pagination: {
      el: ".home-carousel-pagination",
      clickable: true,
    },
    on: {
      init: function (swiperInstance: any) {
        let _animationFrameId: number | null = null;
        const easing = 0.08;

        const animateSprites = () => {
          const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
          if (!activeSlide) return;

          // FIX: Use 'as' casting instead of <HTMLElement> generic
          const parallaxSprites = activeSlide.querySelectorAll(
            ".mouse-parallax-sprite",
          ) as NodeListOf<HTMLElement>;

          parallaxSprites.forEach((sprite) => {
            if (!parallaxStates.has(sprite)) {
              parallaxStates.set(sprite, {
                currentX: 0,
                currentY: 0,
                targetX: 0,
                targetY: 0,
              });
            }

            const state = parallaxStates.get(sprite)!;
            state.currentX += (state.targetX - state.currentX) * easing;
            state.currentY += (state.targetY - state.currentY) * easing;
            sprite.style.transform = `translate3d(${state.currentX}px, ${state.currentY}px, 0)`;
          });

          _animationFrameId = requestAnimationFrame(animateSprites);
        };

        swiperInstance.el.addEventListener("mousemove", (e: MouseEvent) => {
          const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
          if (!activeSlide) return;

          // FIX: Use 'as' casting
          const parallaxSprites = activeSlide.querySelectorAll(
            ".mouse-parallax-sprite",
          ) as NodeListOf<HTMLElement>;
          if (!parallaxSprites.length) return;

          const { clientX, clientY } = e;
          const { left, top, width, height } =
            swiperInstance.el.getBoundingClientRect();

          const x = (clientX - left - width / 2) / (width / 2);
          const y = (clientY - top - height / 2) / (height / 2);

          parallaxSprites.forEach((sprite) => {
            const speed = parseFloat(sprite.dataset.mouseParallaxSpeed || "0");
            const state = parallaxStates.get(sprite);

            if (state) {
              state.targetX = x * speed * 100;
              state.targetY = y * speed * 100;
            }
          });
        });

        swiperInstance.el.addEventListener("mouseleave", () => {
          // FIX: Use 'as' casting
          const allSprites = swiperInstance.el.querySelectorAll(
            ".mouse-parallax-sprite",
          ) as NodeListOf<HTMLElement>;
          allSprites.forEach((sprite) => {
            const state = parallaxStates.get(sprite);
            if (state) {
              state.targetX = 0;
              state.targetY = 0;
            }
          });
        });

        animateSprites();
      },
    },
  });

  console.log("[HomeCarousel] Initialized successfully.");
};
